<template>
  <div>
    <v-alert
      style="border-style: none;"
      :value="true"
      class="org-alert elevation-2"
    >
      Algunos organigramas podrían no estar actualizados, dado el contexto de integración
    </v-alert>
    <breadcrumb v-if="current_user && current_user.length" />
    <div v-else class="breadcrumb">
      <ul>
        <li v-for="(bc, i) in current_user.breadcrumbs" :key="i" :class="{'linked': !!bc.link}">
          <router-link tag="li" :to="bc.link">
            <div v-if="i === current_user.breadcrumbs.length -1">
              <a style="text-decoration: none; color: black; font-weight: bold;">{{bc.name}}</a>
            </div>
            <a v-else style="text-decoration: none; color: black;">{{bc.name}}</a>
          </router-link>
        </li>
      </ul>
    </div>

    <ProfileUserCardMobile
      v-if="$vuetify.breakpoint.smAndDown"
      :currentUser="current_user"
    />

    <ProfileUserCard
      v-else
      :currentUser="current_user"
    />

    <OrganizationChartMobile
      v-if="$vuetify.breakpoint.smAndDown"
      :currentUser="current_user"
      :parents="current_user_parents"
      :companyChart="companyChart"
    />

    <OrganizationChart
      v-else
      :currentUser="current_user"
      :parents="current_user_parents"
      :companyChart="companyChart"
    />
  </div>
</template>

<script>
import OrganizationChart from "@/components/User/OrganizationChart";
import OrganizationChartMobile from "@/components/User/OrganizationChartMobile";
import ProfileUserCard from "@/components/User/ProfileUserCard";
import ProfileUserCardMobile from "@/components/User/ProfileUserCardMobile";
import Breadcrumb from "@/components/General/Breadcrumb";
import { mapState, mapActions } from "vuex";
export default {
  data(){
    return{
    }
  },
  components: {
    Breadcrumb,
    OrganizationChart,
    OrganizationChartMobile,
    ProfileUserCard,
    ProfileUserCardMobile,
  },
  computed: {
    ...mapState("user", ["current_user", "current_user_parents", "companyChart"])
  },
  methods: {
    ...mapActions("user", ["showCompanyChart", "hideCompanyChart"])
  },
  mounted() {
    if (this.$route.query.showOrganigram === 'true'){
      this.showCompanyChart()
    } else {
      this.hideCompanyChart()
    }
  },
};
</script>
<style scoped>
ul {
  display: flex;
  justify-content: left;
  list-style-type: none;
}
ul > li {
  display: flex;
  float: left;
  width: auto;
  color: default;
  font-weight: bold;
  font-size: 1.2em;
  cursor: default;
  align-items: center;
}
ul > li:not(:last-child)::after {
  content: ">";
  float: right;
  font-size: 1.2em;
  margin: 0 0.5em;
  color: light-default;
  cursor: default;
}
.linked {
  cursor: pointer;
  font-size: 1.2em;
  font-weight: normal;
}
.org-alert {
  position: relative;
  overflow: hidden;
  background-color: #f5f5f5 !important;
  color: #515151 !important;
  font-size: 1.2em !important;
  font-weight: bold !important;
  border-radius: 8px;
  
}

.org-alert::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 14px;
  height: 100%;
  background: #d1657b;
}
</style>